// Mapa de assuntos da tela Parâmetros de Remetente (H1, PO1-3259): parâmetros do
// vínculo embarcador × remetente (catálogo EMBARCREMET). Casa pelo Id.
const MAPA_REMETENTE = [
  {
    key: "simulacao",
    titulo: "Simulação",
    descricao: "Como a simulação de frete escolhe a transportadora para este remetente.",
    blocos: [
      {
        titulo: "Ranking de transportadoras",
        campos: [
          {
            id: 19,
            label: "Ranking melhor frete × prazo",
            ajuda: "Ordem de prioridade entre preço e prazo ao escolher a transportadora na simulação deste remetente.",
          },
        ],
      },
    ],
  },
];

export default MAPA_REMETENTE;
